import { CanDeactivateFn } from '@angular/router';

/**
 * Implemented by editors that hold user edits in memory. Leaving such a page silently is the
 * fastest way to lose someone's work, so navigation asks first.
 */
export interface HasUnsavedChanges {
  isDirty(): boolean;
}

export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (component) => {
  if (!component?.isDirty || !component.isDirty()) {
    return true;
  }

  return window.confirm('You have unsaved changes on this page. Leave and discard them?');
};
